import { render, staticRenderFns } from "./BatchReject.vue?vue&type=template&id=48161fdc&"
import script from "./BatchReject.vue?vue&type=script&lang=js&"
export * from "./BatchReject.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1477836768/src/github.com/FebosIO/Febos-AMI/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('48161fdc')) {
      api.createRecord('48161fdc', component.options)
    } else {
      api.reload('48161fdc', component.options)
    }
    module.hot.accept("./BatchReject.vue?vue&type=template&id=48161fdc&", function () {
      api.rerender('48161fdc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/febos/aduanas/batches/views/components/modals/BatchReject.vue"
export default component.exports